export const PhoneAreaCodeAR = {
  "2": [
    "11"
  ],
  "3": [
    "220","221","223","230","236","237","249",
    "260","261","263","264","265","266",
    "280","291","294","297","298","299",
    "341","342","343","345","346","347","348","349",
    "351","353","354","356","357","358",
    "362","364","370","371","372","373","374","375","376","377","379",
    "380","381","382","383","384","385","386","387","388"
  ],
  "4": [
    "2221","2223","2224","2225","2226","2227","2229","2241","2243","2244","2245","2246","2247","2248",
    "2251","2252","2254","2255","2257","2258","2261","2262","2264","2265","2267","2268",
    "2271","2272","2273","2274","2277","2278",
    "2281","2283","2284","2285","2286","2287","2289","2291","2292","2296","2297","2298",
    "2302","2304","2307","2331","2333","2334","2335","2336","2337","2338",
    "2952","2954","2955",
    "3532","3533","3541","3542","3543","3544","3546","3547","3548","3549",
    "3571","3572","3573","3574","3575","3576","3577",
    "3582","3583","3584","3585","3586",
    "2622","2624","2625","2626","2627","2628","2634","2635","2637","2638",
    "2651","2655","2657",
    "2901","2902","2920","2921","2923","2924","2925","2926","2927","2928","2929",
    "2931","2932",
    "2940","2942","2945","2946","2948",
    "2962","2963","2964","2965","2966","2967","2968","2969",
    "2972","2974","2975","2976"
  ]
}
